module.exports = __webpack_public_path__ + "static/media/STWire4.1939d34a.png";